import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const GumroadProducts = ({ tag }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {

const fetchProducts = async () => {
  try {
    let allProducts = [];
    let url = `https://api.gumroad.com/v2/products`;

    while (url) {
      const response = await fetch(url, {
        headers: {
          Authorization: `Bearer ${process.env.REACT_APP_GUMROAD_API_TOKEN}`
        }
      });

      if (!response.ok) throw new Error('Failed to fetch products');

      const data = await response.json();
      allProducts = [...allProducts, ...data.products];

      url = data.next_page_url
        ? `https://api.gumroad.com${data.next_page_url}`
        : null;
    }

    const filteredProducts = tag
      ? allProducts.filter((product) =>
          (product.tags || []).some(
            (t) => t.toLowerCase() === tag.toLowerCase()
          )
        )
      : allProducts;

    setProducts(filteredProducts);
  } catch (error) {
    setError(error.message);
  } finally {
    setLoading(false);
  }
};

    fetchProducts();
  }, [tag]);


  // Helper function to format price in Euros
  const formatPriceInEuros = (priceInCents) => {
    const euroPrice = priceInCents / 100; // Convert cents to euros
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(euroPrice);
  };

  if (loading) {
    return <p>Loading products...</p>;
  }

  if (error) {
    return <p>Error fetching products: {error}</p>;
  }

  return (
    <ProductsContainer>
        <Grid>
            {products.map((product) => (
                <Item key={product.id}>
                    <ProductLink href={product.short_url} target="_blank" rel="noopener noreferrer">
                        {product.preview_url ? (
                            <Img src={product.preview_url} alt={product.name} />
                        ) : (
                            <NoImage>No image available</NoImage>
                        )}
                        <ProductInfo>
                            <Price>{formatPriceInEuros(product.price)}</Price>
                            <ProductName>{product.name}</ProductName>
                        </ProductInfo>
                    </ProductLink>
                </Item>
            ))}
        </Grid>
    </ProductsContainer>
  );
};

const ProductsContainer = styled.div`
    width: 100%;
    padding: 0.5rem 0;
    overflow-x: hidden;

    @media (min-width: 768px) {
        padding: 1rem 0;
    }
`

const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 1rem;
    width: 100%;
    padding: 0 0.5rem;

    @media (min-width: 768px) {
        padding: 0 1rem;
        gap: 2rem;
    }
`

const Item = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    max-width: 100%;
`

const ProductLink = styled.a`
    text-decoration: none;
    color: inherit;
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: transform 0.3s ease;
    width: 100%;
    max-width: 275px;

    &:hover {
        transform: translateY(-5px);
    }
`

const Img = styled.img`
    width: 100%;
    max-width: 275px;
    height: auto;
    border-radius: 0.5rem;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    transition: box-shadow 0.3s ease;

    &:hover {
        box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
    }
`

const NoImage = styled.p`
    width: 100%;
    max-width: 275px;
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f5f5f5;
    border-radius: 0.5rem;
    color: #666;
`

const ProductInfo = styled.div`
    margin-top: 1rem;
    text-align: center;
    width: 100%;
    max-width: 275px;
    padding: 0 0.5rem;
`

const Price = styled.p`
    font-family: "Agrandir-Regular", sans-serif;
    font-weight: 800;
    font-style: normal;
    font-size: 1.2rem;
    color: #333;
    margin-bottom: 0.5rem;
`

const ProductName = styled.h3`
    font-size: 1rem;
    color: #444;
    margin: 0;
    line-height: 1.4;
    width: 100%;
    max-width: 275px;
    word-wrap: break-word;
    overflow-wrap: break-word;
`

export default GumroadProducts;
